import React, {
    useEffect,
    useState,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    getBrowsingCountryIso,
} from '~shared/utils/user';

import {
    useBannersEnabled,
    useBannersPlaceholderId,
    useLanguageIso,
    useIsMobile,
    useIsVip,
    useIsFtd,
    useRmsData,
    useSerialData,
    useIsHybrid,
    useIsPromotionPermitted,
    useIsPromotionRestricted,
} from '~SpectateStore/hooks/clientStateHooks';
import {
    useCountryState,
    useCurrencyIso,
    useCustomerId,
    useUserMode,
} from '~SpectateStore/hooks/userHooks';
import './styles.scss';

const BannersComponent = ({ placeholderId, dataTestId }) => {
    const bannersErrorEventName = 'bannerBuildSliderErrorEvent';

    const [isVisible, setIsVisible] = useState(true);
    const hideBanners = () => setIsVisible(false);

    // config
    const languageCode = useLanguageIso();
    const deviceCode = useIsMobile() ? 'mobile' : 'desktop';

    // segmentation
    const vip = useIsVip();
    const ftd = useIsFtd();
    const countries = getBrowsingCountryIso();
    const currency = useCurrencyIso();
    const countryState = useCountryState();
    const userMode = useUserMode();
    const rms = useRmsData();
    const serials = useSerialData();
    const cid = useCustomerId() || '';
    const isHybrid = useIsHybrid();
    const isPromotionPermitted = useIsPromotionPermitted();
    const isPromotionRestricted = useIsPromotionRestricted();

    useEffect(() => {
        document.addEventListener(bannersErrorEventName, hideBanners);

        return function cleanup() {
            document.removeEventListener(bannersErrorEventName, hideBanners);
        };
    }, []);

    if (!isVisible) {
        return null;
    }

    const config = {
        placeholderId,
        deviceCode,
        languageCode,
    };
    const segmentation = {
        vip: vip !== undefined ? vip : null,
        ftd: ftd !== undefined ? ftd : null,
        countries,
        currency,
        userMode,
        serials: serials !== undefined ? serials : '',
        cid,
        isHybrid,
        isPromotionPermitted: isPromotionPermitted !== undefined ? isPromotionPermitted : null,
        isPromotionRestricted: isPromotionRestricted !== undefined ? isPromotionRestricted : null,
        states: countryState,
        riskFactor: rms !== undefined ? rms : null, // Important!! riskFactor is a wrong field name in banners component!
    };

    const classes = classNames(
        'hpBanners',
        `hpBanners--${deviceCode}`,
    );

    return (
        <div className={classes} data-testid={dataTestId} >
            <banner-slider
                config={JSON.stringify(config)}
                segmentation={JSON.stringify(segmentation)}
            />
        </div>
    );
};

BannersComponent.propTypes = {
    placeholderId: PropTypes.string.isRequired,
    dataTestId: PropTypes.string,
};

const Banners = ({ viewingContext }) => {
    const bannersEnabled = useBannersEnabled();
    const placeholderId = useBannersPlaceholderId(viewingContext);
    const dataTestAttribute = `page-${viewingContext};banner-${viewingContext}`;

    if (!bannersEnabled || !placeholderId) {
        return null;
    }

    return <BannersComponent placeholderId={placeholderId} dataTestId={dataTestAttribute} />;
};

Banners.propTypes = {
    viewingContext: PropTypes.string,
};

Banners.defaultProps = {
    viewingContext: 'generic',
};

export { Banners };
